import { Controller } from "@hotwired/stimulus";
import Datepicker from "stimulus-easepick";

// Connects to data-controller="datepicker"
export default class extends Datepicker {
  connect() {
    this.langValue = "nl-NL";
    this.rangeTooltipValue = false;

    super.connect();

    this.datepicker.on("select", (date) => {
      console.log("yay");
    });

    this.element.addEventListener("change", this.change.bind(this));
  }

  change(event) {
    console.log("Datepicker changed", event);
  }
}
